'use client';

import {
  PRODUCT_TABS_ANCHOR,
  showProductTab,
} from '@eliadmin/core/src/components/dlz/product-detail/anchors';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { stripTags } from '@eliadmin/core/src/utils/dlz/text';

/**
 * Two-line teaser of the description (the variant's own text first, like the core header) and the
 * link to the description tab. Plain text on purpose: a line clamp does not hold across the block
 * elements of admin HTML.
 */
export function BuyBoxDescription() {
  const { t } = useTranslations();
  const product = useVariantsStore(state => state.product);
  const selectedVariant = useVariantsStore(state => state.selectedVariant);

  const description = stripTags(
    selectedVariant?.short_description ||
      selectedVariant?.description ||
      product.short_description ||
      product.description,
  );
  if (!description) return null;

  return (
    <div className="flex flex-col gap-2 lg:gap-3">
      <p className="dlz-body-m line-clamp-2 text-[#4F545C]">{description}</p>
      <a
        href={`#${PRODUCT_TABS_ANCHOR}`}
        onClick={event => {
          event.preventDefault();
          showProductTab('popis');
        }}
        // The caption is trimmed to its cap height (12 px), the pseudo-element restores a 44 px target.
        className="dlz-button-l relative w-fit rounded-sm text-[#D7191F] after:absolute after:-inset-x-2 after:-inset-y-4 after:content-[''] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012] focus-visible:ring-offset-4"
      >
        <span className="dlz-trim block">{t('text529')}</span>
      </a>
    </div>
  );
}

/** Figma „Highlights“: the „Hlavné vlastnosti“ of the product with a red check each. */
export function BuyBoxHighlights({ items }: { items: string[] }) {
  if (!items.length) return null;

  return (
    <ul className="flex flex-col gap-2">
      {items.map(item => (
        <li key={item} className="flex items-center gap-2">
          <Icon name="check-circle" size={24} className="text-[#D7191F]" />
          <span className="dlz-body-s text-[#0F1012]">{item}</span>
        </li>
      ))}
    </ul>
  );
}
